module.exports = __webpack_public_path__ + "static/media/note8-alt.4c3ac83a.wav";